export const Article = "article";
export const NotFound = "404";
